export default __webpack_public_path__ + "static/media/ic_trx_96.e3c7bb9a.svg";